"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USW_COMPONENT_TYPES = exports.TYPE = exports.TRIP_TYPE_DATA = exports.TRIP_TYPES = exports.TRAVEL_CLASS_TITLE = exports.TRAVEL_CLASS_CONFIG = exports.TRAVEL_CLASS = exports.STATION_TYPES = exports.STATION_ICONS = exports.SNAP_WINDOW = exports.SNAP_DATA = exports.REDIRECT_URL = exports.PREFILL_TEST_DATA = exports.PLATFORM = exports.PAX_TRANSLATION_KEYS = exports.PASSENGER_SELECTION_DATA = exports.MAX_DAYS = exports.LOCAL_HOST_URL = exports.LFC_ROLE = exports.LFC_MEMBER_V2 = exports.LFC_MEMBER = exports.LABEL_RETURN = exports.LABEL_DEPART = exports.ITEMS = exports.GTM_TAGS = exports.ENVIRONMENT_URL = exports.ENVIRONMENT = exports.DEFAULT_LOCALE = exports.DEFAULT_GEOID = exports.DEFAULT_CURRENCY = exports.DEFAULT_CONTEXTUAL_PRODUCT_ID = exports.DATE_FORMAT = exports.DATA_VISOR_EVENT = exports.DATAFORMAT_DATA = exports.COOKIE_OBJECT_FLIGHT = exports.CHANNEL_HASH = exports.BOOLEAN = exports.ASYNC_DATA_KEYS = exports.AIRLINE_PROFILE = exports.AIRLINES = exports.ACTION_CONSTANTS = exports.AA_GAID_COOKIE_NAME = void 0;
var USW_COMPONENT_TYPES = {
  HERO_BANNER: 'heroBanner',
  PLACEPICKER: 'placepicker',
  DATEPICKER: 'datepicker',
  MULTI_ROOM_SELECT: 'multi_room_select',
  PAX_COUNTER: 'passenger_counter',
  DROPDOWN: 'dropdown',
  LINK: 'link',
  CHECKBOX: 'checkbox',
  BUTTON: 'button',
  PROMOCODE: 'promoCode',
  TRIP_TYPE: 'trip_type',
  SNAP_CHECKBOX: 'snapCheckbox'
};
exports.USW_COMPONENT_TYPES = USW_COMPONENT_TYPES;
var LFC_MEMBER = {
  ANONYMOUS: 0,
  LOGGEDIN: 1
};
exports.LFC_MEMBER = LFC_MEMBER;
var LFC_MEMBER_V2 = {
  ANONYMOUS: 'anonymous',
  LOGGEDIN: 'member'
};
exports.LFC_MEMBER_V2 = LFC_MEMBER_V2;
var BOOLEAN = {
  FALSE: 'false',
  TRUE: 'true'
};
exports.BOOLEAN = BOOLEAN;
var LFC_ROLE = {
  DESKTOP: 0,
  MOBILE: 1
};
exports.LFC_ROLE = LFC_ROLE;
var LOCAL_HOST_URL = 'http://local.airasia.com:4200/';
exports.LOCAL_HOST_URL = LOCAL_HOST_URL;
var LABEL_DEPART = 'Depart date';
exports.LABEL_DEPART = LABEL_DEPART;
var LABEL_RETURN = 'Return Date';
exports.LABEL_RETURN = LABEL_RETURN;
var DATAFORMAT_DATA = {
  date: {
    noYear: 'dd mmm',
    fullWithDay: 'ddd, dd mmm',
    noDay: 'mmm yyyy',
    abbreviate: 'dd mmm yyyy',
    general: 'dd/mm/yyyy'
  },
  shortDaysTranslation: {
    wed: 'Wed',
    sun: 'Sun',
    fri: 'Fri',
    tue: 'Tue',
    mon: 'Mon',
    thu: 'Thu',
    sat: 'Sat'
  },
  shortMonthTranslation: {
    mar: 'Mar',
    feb: 'Feb',
    aug: 'Aug',
    sep: 'Sep',
    apr: 'Apr',
    jun: 'Jun',
    jul: 'Jul',
    jan: 'Jan',
    may: 'May',
    nov: 'Nov',
    dec: 'Dec',
    oct: 'Oct'
  },
  fullDaysTranslation: {
    wed: 'Wednesday',
    sun: 'Sunday',
    fri: 'Friday',
    tue: 'Tuesday',
    mon: 'Monday',
    thu: 'Thursday',
    sat: 'Saturday'
  },
  fullMonthTranslation: {
    mar: 'March',
    feb: 'February',
    aug: 'August',
    sep: 'September',
    apr: 'April',
    jun: 'June',
    jul: 'July',
    jan: 'January',
    may: 'May',
    nov: 'November',
    dec: 'December',
    oct: 'October'
  },
  letterDaysTranslation: {
    wed: 'W',
    sun: 'S',
    fri: 'F',
    tue: 'T',
    mon: 'M',
    thu: 'T',
    sat: 'S'
  }
};
exports.DATAFORMAT_DATA = DATAFORMAT_DATA;
var ITEMS = [{
  iconName: 'LocationOnIcon',
  iconDisplayName: 'city',
  mainDisplayName: 'port Dicksonaaa',
  airportCode: 'DMK',
  value: {}
}, {
  iconName: 'HotelIcon',
  iconDisplayName: 'airport',
  mainDisplayName: 'port Dicksonbbb',
  airportCode: 'DMK',
  value: {}
}];
exports.ITEMS = ITEMS;
var PASSENGER_SELECTION_DATA = {
  min: 3,
  max: 24,
  adult: {
    type: 'adult',
    label: 'Adult',
    subLabel: '18 years and above',
    min: 'infant',
    max: '12'
  },
  child: {
    type: 'child',
    label: 'Child',
    subLabel: 'Between 12 years and 17 years',
    min: 0,
    max: '6'
  },
  infant: {
    type: 'infant',
    label: 'Infant',
    subLabel: '0 years',
    max: 'adult',
    min: 0
  },
  passengerCount: {
    adult: 2,
    child: 1,
    infant: 0
  }
};
exports.PASSENGER_SELECTION_DATA = PASSENGER_SELECTION_DATA;
var ACTION_CONSTANTS = {
  DATA_FETCH_START: 'DATA_FETCH_START',
  DATA_FETCH_SUCCESS: 'DATA_FETCH_SUCCESS',
  DATA_FETCH_FAILURE: 'DATA_FETCH_FAILURE'
};
exports.ACTION_CONSTANTS = ACTION_CONSTANTS;
var TYPE = {
  PAIRED: 'paired',
  BUNDLED: 'bundled'
};
exports.TYPE = TYPE;
var AIRLINE_PROFILE = {
  DOTREZ: 'dotrez',
  KIWI: 'kiwi',
  ALL: 'all'
};
exports.AIRLINE_PROFILE = AIRLINE_PROFILE;
var ENVIRONMENT = {
  DEVELOPMENT: 'DEVELOPMENT',
  PRE_PRODUCTION: 'PRE_PRODUCTION',
  PRODUCTION: 'PRODUCTION',
  STAGING: 'STAGING'
};
exports.ENVIRONMENT = ENVIRONMENT;
var ENVIRONMENT_URL = {
  DEVELOPMENT: {
    AA_BASE_URL: 'https://www.devairasia.com/',
    AA_FLIGHT_SEARCH_PATH_PARAMETERS: 'select/{locale}/{origin}/{destination}/{departureDate}/{returnDate}/{adult}/{child}/{infant}/{tripType}/' + '{promoCode}/{currency}/{sortType}',
    AA_MULTI_CITY_URL: 'https://flybeyond.airasia.com/en/landing/multicity',
    KONG_URL: 'https://k.dev-apiairasia.com',
    GCS_URL: 'https://ppsch.apiairasia.com',
    FEATURE_FLAG_ENV: 'dev',
    LISTING_APP_URL: 'https://www.devairasia.com/flights/search/',
    AAI_BASE_URL: 'https://preprod.airasia.co.in/flight-availability?/',
    SNAP_URL: 'snap/hotels/list',
    STATIC_URL: 'https://static.stgairasia.com',
    FUNNEL_CONTROL_URL: 'https://flights.devairasia.com/fp/funnels'
  },
  PRE_PRODUCTION: {
    AA_BASE_URL: 'https://www.ppairasia.com/',
    AA_FLIGHT_SEARCH_PATH_PARAMETERS: 'select/{locale}/{origin}/{destination}/{departureDate}/{returnDate}/{adult}/{child}/{infant}/{tripType}/' + '{promoCode}/{currency}/{sortType}',
    AA_MULTI_CITY_URL: 'https://flybeyond.airasia.com/en/landing/multicity',
    KONG_URL: 'https://k.preprod-apiairasia.com',
    GCS_URL: 'https://sch.apiairasia.com',
    FEATURE_FLAG_ENV: 'preprod',
    LISTING_APP_URL: 'https://www.ppairasia.com/flights/search/',
    AAI_BASE_URL: 'https://www.airasia.co.in/flight-availability?/',
    SNAP_URL: 'snap/hotels/list',
    STATIC_URL: 'https://static.airasia.com',
    FUNNEL_CONTROL_URL: 'https://flights.ppairasia.com/fp/funnels'
  },
  PRODUCTION: {
    AA_BASE_URL: 'https://www.airasia.com/',
    AA_FLIGHT_SEARCH_PATH_PARAMETERS: 'select/{locale}/{origin}/{destination}/{departureDate}/{returnDate}/{adult}/{child}/{infant}/{tripType}/' + '{promoCode}/{currency}/{sortType}',
    AA_MULTI_CITY_URL: 'https://flybeyond.airasia.com/en/landing/multicity',
    KONG_URL: 'https://k.airasia.com',
    GCS_URL: 'https://sch.apiairasia.com',
    FEATURE_FLAG_ENV: 'production',
    LISTING_APP_URL: 'https://www.airasia.com/flights/search/',
    AAI_BASE_URL: 'https://www.airasia.co.in/flight-availability?/',
    SNAP_URL: 'snap/hotels/list',
    STATIC_URL: 'https://static.airasia.com',
    FUNNEL_CONTROL_URL: 'https://flights.airasia.com/fp/funnels'
  },
  STAGING: {
    AA_BASE_URL: 'https://www.stgairasia.com/',
    AA_FLIGHT_SEARCH_PATH_PARAMETERS: 'select/{locale}/{origin}/{destination}/{departureDate}/{returnDate}/{adult}/{child}/{infant}/{tripType}/' + '{promoCode}/{currency}/{sortType}',
    AA_MULTI_CITY_URL: 'https://flybeyond.airasia.com/en/landing/multicity',
    KONG_URL: 'https://k.stg-apiairasia.com',
    GCS_URL: 'https://ppsch.apiairasia.com',
    FEATURE_FLAG_ENV: 'staging',
    LISTING_APP_URL: 'https://www.stgairasia.com/flights/search/',
    AAI_BASE_URL: 'https://preprod.airasia.co.in/flight-availability?/',
    SNAP_URL: 'snap/hotels/list',
    STATIC_URL: 'https://static.stgairasia.com',
    FUNNEL_CONTROL_URL: 'https://flights.stgairasia.com/fp/funnels'
  }
};
exports.ENVIRONMENT_URL = ENVIRONMENT_URL;
var ASYNC_DATA_KEYS = {
  FEATURE_FLAG: 'feature_flag',
  ORIGIN_STATIONS: 'originStationsData',
  SEARCH_DEEP_LINK: 'searchDeepLink',
  DATA_VISOR: 'dataVisor',
  NEAREST_AIRPORT: 'nearest_airport',
  DESTINATION_STATIONS: 'destination_stations',
  BASE_CURRENCY: 'baseCurrency',
  CALENDAR_DATA: 'calendarDateFormatData',
  MULTI_CURRENCY: 'multiCurrency',
  OTA_GEOID_LIST: 'otaGeoidList',
  FUNNEL_CONTROL_SERVICE: 'funnelControlService'
};
exports.ASYNC_DATA_KEYS = ASYNC_DATA_KEYS;
var DEFAULT_LOCALE = 'en-gb';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var DEFAULT_CURRENCY = 'USD';
exports.DEFAULT_CURRENCY = DEFAULT_CURRENCY;
var DEFAULT_GEOID = 'MY';
exports.DEFAULT_GEOID = DEFAULT_GEOID;
var STATION_TYPES = {
  AIR_PORTS: 'A',
  FERIES: 'F',
  HOTEL_OR_BUSES: 'B'
};
exports.STATION_TYPES = STATION_TYPES;
var STATION_ICONS = {
  AIR_PORTS_ICON: 'FlightIcon',
  HOTEL_OR_BUSES_ICON: 'ApartmentIcon',
  FERIES_ICON: 'IslandTransfer',
  LOCATION_ON_ICON: 'LocationOnIcon',
  RECENT_SEARCH_ICON: 'History',
  CALL_MADE_ICON: 'CallMadeIcon'
}; // export const KIWI_PARAMETERS = {
//   BASE_URL: 'https://flybeyond.airasia.com/deep?',
//   BRAND: 'airasia',
//   AFFILIATE_ID: 'airasiaberhadwl',
// };

exports.STATION_ICONS = STATION_ICONS;
var COOKIE_OBJECT_FLIGHT = '{origin}|{destination}|{originCountry}|{destinationCountry}|{StationName}|{DepartStationName}|{depart}' + '|{return}|{adult}|{children}|{infant}|{tripType}|{created_at}|{promo}|{IsDepartKiwiStation}|{IsArrivalKiwiStation}' + '|{IsKiwiRoute}';
exports.COOKIE_OBJECT_FLIGHT = COOKIE_OBJECT_FLIGHT;
var DATE_FORMAT = {
  KIWI_DATE_FORMAT: 'dd-MM-yyyy',
  AA_DATE_FORMAT: 'yyyy-MM-dd',
  LISTING_DATE_FORMAT: 'dd/MM/yyyy',
  RECENT_SEARCH_FORMAT: 'MM/dd/yyyy'
};
exports.DATE_FORMAT = DATE_FORMAT;
var AIRLINES = {
  FLYBEYOND: 'FLYBEYOND',
  AAI: 'AAI',
  AAB: 'AAB',
  OTA: 'OTA'
};
exports.AIRLINES = AIRLINES;
var TRIP_TYPES = {
  RETURN: 'R',
  ONE_WAY: 'O'
};
exports.TRIP_TYPES = TRIP_TYPES;
var CHANNEL_HASH = {
  mobileWeb: '98ba1fad5baab2959fd06259acc292c6ebf46e210735882afc32a084',
  web: '906a14a4c039ea4af65874742638ddae5c3ec9c6bbc9026eea35f00f'
};
exports.CHANNEL_HASH = CHANNEL_HASH;
var DATA_VISOR_EVENT = {
  EDIT_PAGE: 'editsearch',
  HOME_PAGE: 'homepage'
};
exports.DATA_VISOR_EVENT = DATA_VISOR_EVENT;
var PREFILL_TEST_DATA = {
  promoCode: 'NZR',
  from: 'LCY',
  to: 'BLR',
  tripType: 'O',
  // O for oneway, R for return
  depart: '05/19/2020',
  // mm/dd/yyyy
  return: '05/20/2020',
  passengers: {
    adult: 4,
    child: 1,
    infant: 3
  }
};
exports.PREFILL_TEST_DATA = PREFILL_TEST_DATA;
var TRIP_TYPE_DATA = [{
  label: 'Round Trip',
  selectionType: 'select',
  code: 'R'
}, {
  label: 'One-way',
  selectionType: 'select',
  code: 'O'
}, {
  label: 'Multi-city',
  selectionType: 'redirect',
  code: 'M',
  url: 'https://flybeyond.airasia.com/en/landing/multicity'
}];
exports.TRIP_TYPE_DATA = TRIP_TYPE_DATA;
var PAX_TRANSLATION_KEYS = {
  ADULT: 'adultSingle',
  ADULT_AGE_LIMIT: 'adultAgeLimit',
  CHILD: 'childSingle',
  CHILD_AGE_LIMIT: 'childAgeLimit',
  INFANT: 'infantSingle',
  INFANT_AGE_LIMIT: 'infantAgeLimit'
};
exports.PAX_TRANSLATION_KEYS = PAX_TRANSLATION_KEYS;
var GTM_TAGS = {
  RECENT_SEARCHES: 'recent.fs.list',
  NEAREST_AIRPORT: 'nearest.fs.list',
  GENERAL: 'gnral',
  OTA: 'ota',
  FLIGHTS: 'flights',
  ONEWAY: 'Oneway',
  RETURN: 'Return'
};
exports.GTM_TAGS = GTM_TAGS;
var AA_GAID_COOKIE_NAME = '__airasiaga';
exports.AA_GAID_COOKIE_NAME = AA_GAID_COOKIE_NAME;
var DEFAULT_CONTEXTUAL_PRODUCT_ID = 'flights';
exports.DEFAULT_CONTEXTUAL_PRODUCT_ID = DEFAULT_CONTEXTUAL_PRODUCT_ID;
var SNAP_DATA = {
  MAX_PASSENGERS: 6,
  CHILD_AGE_DEFAULT: '1_11',
  INFANT_AGE_DEFAULT: '1_1'
};
exports.SNAP_DATA = SNAP_DATA;
var SNAP_WINDOW = {
  WIDTH: 520,
  HEIGHT: 570
};
exports.SNAP_WINDOW = SNAP_WINDOW;
var TRAVEL_CLASS = {
  DEFAULT: 'economy',
  ECONOMY: 'economy',
  PREMIUM_ECONOMY: 'premium_economy',
  PREMIUM: 'premium',
  SPECIAL_CLASS: 'special_class'
};
exports.TRAVEL_CLASS = TRAVEL_CLASS;
var PLATFORM = {
  WEB: 'web',
  MOBILE: 'mobile'
};
exports.PLATFORM = PLATFORM;
var REDIRECT_URL = 'https://www.airasia.com';
exports.REDIRECT_URL = REDIRECT_URL;
var MAX_DAYS = 510;
exports.MAX_DAYS = MAX_DAYS;
var TRAVEL_CLASS_CONFIG = [{
  data: [{
    label: 'Economy',
    value: 'economy',
    code: 'M'
  }, {
    label: 'Business',
    value: 'business',
    code: 'C'
  }, {
    label: 'Premium Economy',
    value: 'premium',
    code: 'W'
  }, {
    label: 'First Class',
    value: 'first',
    code: 'F'
  }]
}];
exports.TRAVEL_CLASS_CONFIG = TRAVEL_CLASS_CONFIG;
var TRAVEL_CLASS_TITLE = 'Travel Class';
exports.TRAVEL_CLASS_TITLE = TRAVEL_CLASS_TITLE;